import {
  myAxios as axios
} from '@http/index'

const serve = "/user-center";
const jsonConfig = {
  transformRequest: [
    function (data) {
      data = JSON.stringify(data);
      return data
    },
  ],
  headers: {
    'Content-Type': 'application/json'
  },
}

/**
 * 获取菜单列表
 * @param params 请求参数
 * @returns {*}
 */
export const MenuList = (param) => {
  return axios({
    url: `${serve}/plmenu/getMenu.ajax`,
    data: param
  })
}

/**
 * 获取y用户信息
 * @returns {*}
 */
export const statffStatus = () => {
  return axios({
    url: `${serve}/comLogin/statffStatus.ajax`
  })
}

/**
* 获取检验报告带发送企业
* @param params
*/
export const getCheckCompanyRecommendList = (param) => {
  return axios({
    url: `${serve}/companyRecommend/getCheckCompanyRecommendList.ajax`,
    data: param,
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

/**
* 微信扫码上传二维码
* @param params
*/
export const getWxUploadCode = (param) => {
  return axios({
    url: `${serve}/account/getWxUploadCode.ajax`,
    data: param,
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

/**
 * 退出登录
 * @returns {*}
 */
export const logout = () => {
  return axios({
    url: `${serve}/lportal/logout.ajax`
  })
}

/**
 * 获取空间大小
 * @returns {*}
 */
export const getCompanyStorageSize = () => {
  return axios({
    url: `${serve}/company/getCompanyStorageSize.ajax`,
    data: {},
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

/**
 * 获取空间大小
 * @returns {*}
 */
export const getCompanyStorageSize2 = () => {
  return axios({
    url: `${serve}/company/getCompanyStorageSize2.ajax`,
    method:'get',
    data: {},
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}



/**
 * 获取邀请码
 * @returns {*}
 */
export const getQRCode = (param) => {
  return axios({
    url: `${serve}/account/getQRCode.ajax`,
    data: param,
  })
}


/**
 * 获取套餐信息
 * @returns {*}
 */
export const selectComboByCompId = () => {
  return axios({
    url: `${serve}/order/selectComboByCompId.ajax`,
  })
}

/**
 * 获取订单列表
 * @returns {*}
 */
export const queryOrder = (param) => {
  return axios({
    url: `${serve}/order/queryOrder.ajax`,
    data: param,
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

/**
 * 取消订单
 * @returns {*}
 */
export const cancelOrder = (param) => {
  return axios({
    url: `${serve}/order/cancelOrder.ajax`,
    data: param,
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

/**
 * 获取订单合同
 * @returns {*}
 */
export const queryOrderById = (param) => {
  return axios({
    url: `${serve}/orderCompany/queryOrderById.ajax`,
    data: param,
  })
}

/**
 * 拒绝合同
 * @returns {*}
 */
export const contractConfirm = (param) => {
  return axios({
    url: `${serve}/orderCompany/contractConfirm.ajax`,
    data: param,
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

/**
 * 订单合同保存签章信息
 * @returns {*}
 */
export const stampSave = (param) => {
  return axios({
    url: `${serve}/orderCompany/stampSave.ajax`,
    data: param,
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

/**
 * 订单合同保存签章信息
 * @returns {*}
 */
export const selectComboBy = (param) => {
  return axios({
    url: `${serve}/order/selectComboBy.ajax`,
    data: param,
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

/**
 * 获取用户套餐的可接收发送文件数量
 * @returns {*}
 */
export const getCompanyCountDetails = () => {
  return axios({
    url: `${serve}/companyPackage/getCompanyCountDetails.ajax`
  })
}

/**
 * 补充合同
 * @returns {*}
 */
export const supplementContract = (param) => {
  return axios({
    url: `${serve}/orderCompany/supplementContract.ajax`,
    data: param,
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

/**
 * 删除合同
 * @returns {*}
 */
export const hideOrder = (param) => {
  return axios({
    url: `${serve}/order/hideOrder.ajax`,
    data: param,
  })
}

/**
 * 监管端获取用户信息
 * @returns {*}
 */
export const accManager = () => {
  return axios({
    url: `${serve}/account/accManager.ajax`,
  })
}

/**
 * 修改用户密码
 * @returns {*}
 */
export const changePwd = (param) => {
  return axios({
    url: `${serve}/staff/changePwd.ajax`,
    data: param
  })
}

/**
 * 验证手机验证码
 * @returns {*}
 */
export const checkYzm = (param) => {
  return axios({
    url: `${serve}/phone/checkYzm.ajax`,
    data: param
  })
}

/**
 *修改手机号码
 * @returns {*}
 */
export const updatePhone = (param) => {
  return axios({
    url: `${serve}/account/updatePhone.ajax`,
    data: param
  })
}

/**
 *校验手机号码是否使用过
 * @returns {*}
 */
export const checkPhoneNum = (param) => {
  return axios({
    url: `${serve}/phone/checkPhoneNum.ajax`,
    data: param
  })
}

/**
 *发送验证码
 * @returns {*}
 */
export const sendToUser = (param) => {
  return axios({
    url: `${serve}/phone/sendToUser.ajax`,
    data: param
  })
}

/**
 * 管辖区域
 * @returns {*}
 */
export const getJurisdictionArea = (param) => {
  return axios({
    url: `${serve}/company/getJurisdictionArea.ajax`,
    data: param,
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

/**
 * 企业数量地区分布
 * @returns {*}
 */
export const getCompanyDistribution = (param) => {
  return axios({
    url: `${serve}/company/getCompanyDistribution.ajax`,
    data: param,
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

/**
 * 企业类型占比
 * @returns {*}
 */
 export const statisticalCompanyType = (param) => {
  return axios({
    url: `${serve}/companyExchange/statisticalCompanyType.ajax`,
    data: param,
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

/**
 * 企业类别
 * @returns {*}
 */
export const getAccountMangeServerType = (param) => {
  return axios({
    url: `${serve}/account/getAccountMangeServerType.ajax`,
    data: param,
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

/**
 * 监管端查企业详情
 * @returns {*}
 */
export const getCompanyInfoForSuper = (param) => {
  return axios({
    url: `${serve}/company/getCompanyInfoForSuper.ajax`,
    data: param,
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

/**
 * 获取平台企业信息
 * @returns {*}
 */
export const getCompanyNameListPage = (param) => {
  return axios({
    url: `${serve}/company/getCompanyNameList.ajax`,
    data: param,
    ...jsonConfig
  })
}

/**
 * 企业认领提交
 * @returns {*}
 */
export const addClaim = (param) => {
  return axios({
    url: `${serve}/accountClaim/addClaim.ajax`,
    data: param,
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

/**
 * 获取滑动图像验证
 * @returns {*}
 */
export const getPuzzleCaptcha = (param) => {
  return axios({
    url: `${serve}/puzzleCaptcha/getPuzzleCaptcha.ajax`,
    data: param,
  })
}

/**
 * 同步企查查次数校验
 * @param params
 */
export const CheckQichachaClickNum = () => {
  return axios({
    method: 'get',
    url: `${serve}/companyPackage/CheckQichachaClickNum`,
  })
}

/**
 * 获取登录企业信息
 * @returns {*}
 */
export const getCompanyInfo = (param) => {
  return axios({
    url: `${serve}/company/getCompanyInfo.ajax`,
    data: param,
  })
}

/**
 * 获取登录企业信息
 * @returns {*}
 */
export const getChangeResoreList = (param) => {
  return axios({
    url: `${serve}/compChangeResore/getChangeResoreList.ajax`,
    data: param,
  })
}

/**
 * 新增修改邮箱
 * @returns {*}
 */
export const changeStaffInfo = (param) => {
  return axios({
    url: `${serve}/account/changeStaffInfo.ajax`,
    data: param,
  })
}
/**
 * 获取开户列表
 * @param params
 */
export const getOpenAccountList = (params) => {
  return axios({
    url: `${serve}/company/getAccountOpeningRecord.ajax`,
    data: params,
    ...jsonConfig
  })
}
/**
 * 开户申请
 * @param params
 */
export const openAccountApply = (params) => {
  return axios({
    url: `${serve}/companyPackageAccountOpen/applyAccount.ajax`,
    data: params,
    ...jsonConfig
  })
}
/**
 * 获取可开户数量 / 开户配置
 * @param params
 */
export const getAccountOpenConfig = () => {
  return axios({
    method: 'get',
    url: `${serve}/company/getAccountOpeningRecordNum.ajax`
  })
}


/**
 * 可退余额总数
 * @returns {*}
 */
export const getRefundNum = () => {
  return axios({
    method: 'post',
    url: `${serve}/newRefund/getRefundNum.ajax`
  })
}
/**
 * 退费申请列表
 * @returns {*}
 */
export const getRefundList = () => {
  return axios({
    method: 'post',
    url: `${serve}/newRefund/listRefund.ajax`
  })
}
/**
 * 退费申请
 * @param param
 * @returns {*}
 */
export const refundApply = (param) => {
  return axios({
    method: 'post',
    url: `${serve}/newRefund/refundApply.ajax`,
    data:param,
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}
/**
 * 取消退费
 */
export const refundCancel = (param) => {
  return axios({
    url: `${serve}/newRefund/refundCancel.ajax`,
    data:param,
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

/**
 * 退费详情
 */
export const refundDetails = (param) => {
  return axios({
    url: `${serve}/newRefund/refundById.ajax`,
    data:param,
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

/**
 * 获取充值金额配置
 * @returns {*}
 */
export const getRechargeConfig = () => {
  return axios({
    method: 'post',
    url: `${serve}/orderCompany/getRechargeConfig.ajax`
  })
}

/**
 * 关闭初次企业顾问弹框
 * @returns {*}
 */
 export const saveCompanyConsultant = () => {
  return axios({
    method: 'post',
    url: `${serve}/CompanyConsultant/saveCompanyConsultant.ajax`
  })
}
/**
 * 行政消息
 * @param param
 * @returns {*}
 */
export const requestAdministrativeNews = (param) => {
  return axios({
    url: `${serve}/company/getInformationList.ajax`,
    data:param,
    transformRequest: [
      function (data) {
        data = JSON.stringify(data);
        return data
      },
    ],
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

/**
 * 企业审核状态变更重新登录
 * @returns {*}
 */
export const updateSession = () => {
  return axios({
    url: `${serve}/lportal/updateSession.ajax`,
  })
}